/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import orderClasses from "../../orders/orders.module.css";
import reportClasses from "../reports.module.css";
import OrderTable from "./orderReportTable";
import Input from "../../../../component/inputpm";
import Loader from "../../../../component/loader";
import ResendDialog from "../../order/resendDialog";
import IconButton from "@mui/material/IconButton";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
//import Select from '../../../component/select';
import Select from "@mui/material/Select";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";

import TextField from "@mui/material/TextField";
import moment from "moment";
import Breadcrumb from "../../../../component/breadcrumb";
import Paper from "@mui/material/Paper";
import { SearchIcon, ClearIcon } from "../../../../component/icons/icons";
import { Grid, Card, InputLabel, FormControl } from "@mui/material";
import dateFormat from "dateformat";
import formatDate from "../../../../helper/dateFormatter";

// Manage order page class
class OrderReport extends Component {
  // Declare property values that belongs to the component
  state = {
    orders: [],
    orderId: "",
    customerName: "",
    customerBAN: "",
    orderStatus: "All Orders",
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalOrderCount: 0,
    loading: true,
    actionOrderId: "",
    isMailDialog: false,
    sortBy: "orderDate",
    sortOrder: "DESC",
    controls: true,
    orderType: "",
    amount: "",
    orderFromDate: "",
    orderToDate: "",
    clientName: "",

    orderTypeList: [
      {
        name: "All",
        value: "",
      },
      {
        name: "Sales",
        value: "SALES_ORDER",
      },
      {
        name: "Purchase",
        value: "PURCHASE_ORDER",
      },
    ],
    // Order status list
    statusList: [],
    bread: [
      { title: this.props.t("REPORTS"), url: "/orderReport" },
      { title: this.props.t("ORDERS_REPORT"), url: "/orderReport" },
    ],
    today: moment(new Date()).format("yyyy-MM-DD"),
    tenant: "",
    tenantList: [],
    displayOrderStatus: false,
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ORDER_STATUSES/endpoint`,
      {},
    ).then((res) => {
      let list = res.data;
      let all = {
        name: this.props.t("All Orders"),
        value: "All Orders",
      };
      list.unshift(all);
      this.setState(
        {
          statusList: res.data,
        },
        () => {
          this.setState({
            displayOrderStatus: true,
          });
        },
      );
    });
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/GET_CHILD_TENANT_LIST/endpoint`,
        {},
      )
        .then((res) => {
          let list = res.data.tenants;
          this.setState(
            {
              tenantList: list,
            },
            () => {
              if (list && list.length > 0) {
                let initialFilters = JSON.parse(
                  localStorage.getItem("orderFilters"),
                );
                this.setState({
                  tenant:
                    initialFilters && initialFilters.tenant
                      ? initialFilters.tenant
                      : list[0].tenantId,
                });
              }
              this.callGetOrders();
            },
          );
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      this.callGetOrders();
    }
  }

  callGetOrders = () => {
    let initialFilters = JSON.parse(localStorage.getItem("orderFilters"));
    if (initialFilters) {
      this.setState(
        {
          rowsPerPage: initialFilters.rowsPerPage,
          startRecord: initialFilters.startRecord,
          page: initialFilters.page,
          sortBy: initialFilters.sortBy,
          sortOrder: initialFilters.sortOrder,
          orderId: initialFilters.orderId,
          orderStatus: initialFilters.orderStatus,
          customerBAN: initialFilters.customerBAN,
          customerName: initialFilters.customerName,
          amount: initialFilters.amount,
          orderFromDate: this.state.orderFromDate,
          orderToDate: this.state.orderToDate,
          orderType: initialFilters.orderType,
          clientName: initialFilters.clientName,
        },
        () => {
          this.getOrders();
        },
      );
    } else {
      this.getOrders();
    }
  };
  convertDate(date) {
    return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  }

  convertTillDateParam(date) {
    return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
  }

  // Fetch orders list
  getOrders = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    // START: Store order filters data
    let orderFilters = {
      rowsPerPage: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
      page: this.state.page,
      sortBy: this.state.sortBy,
      sortOrder: this.state.sortOrder,

      orderId: this.state.orderId,
      orderStatus:
        this.state.orderStatus === "All Orders" ? "" : this.state.orderStatus,
      customerBAN: this.state.customerBAN,
      customerName: this.state.customerName,
      amount: this.state.amount,
      orderFromDate: this.state.orderFromDate
        // ? this.convertDate(this.state.orderFromDate)
        ? formatDate(this.state.orderFromDate)
        : "",
      orderToDate: this.state.orderToDate
        // ? this.convertTillDateParam(this.state.orderToDate)
        ? formatDate(this.state.orderToDate)
        : "",
      clientName: this.state.clientName,
    };
    localStorage.setItem("orderFilters", JSON.stringify(orderFilters));
    // END: Store order filters data
    let filters = `sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&orderId=${this.state.orderId}&orderStatus=${encodeURIComponent(this.state.orderStatus)}&customerName=${this.state.customerName}&customerBan=${this.state.customerBAN}&clientName=${this.state.clientName ? this.state.clientName : ""}&amount=${this.state.amount ? this.state.amount : ""}&from=${encodeURIComponent(orderFilters.orderFromDate)}&to=${encodeURIComponent(orderFilters.orderToDate)}`;
    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders?${filters}`,
      this.props.providerType === "SOLUTION_PROVIDER"
        ? {
            tenantId:
              this.state.tenant != ""
                ? this.state.tenant
                : this.state.tenantList[0]
                  ? this.state.tenantList[0].tenantId
                  : "",
          }
        : {},
      pageOptions,
    )
      .then((res) => {
        let data = res.data;
        if (data.length > 0) {
          for (let item of data) {
            item.accountName = item.customer.companyName;
            item.ban = item.customer.ban;
            // Check whether the order is auto-activated or not
            // for (let userItem of item.userData) {
            //     if (userItem.name === 'autoActivatable') {
            //         item.autoActivatable = userItem.value
            //     }
            // }
          }
          this.setState({
            orders: data,
            totalOrderCount: +res.headers["x-total-count"],
            loading: false,
          });
        } else {
          this.setState({
            orders: [],
            totalOrderCount: 0,
            loading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // Update state data on input change
  onChange = (e) => {
    if (e.target.name === "orderFromDate") {
      this.setState({
        orderToDate: "",
      });
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Open resend confirmation email modal
  openResendDialog = (orderId) => {
    this.setState({
      isMailDialog: true,
      actionOrderId: orderId,
    });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Close confirmation email dialog
  closeMailDialog = () => {
    this.setState({
      isMailDialog: false,
      actionOrderId: "",
    });
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getOrders();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getOrders();
        },
      );
    }
  };

  // Search/Filter orders
  filterOrderTable = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        orderId: this.state.orderId,
        customerName: this.state.customerName,
        customerBAN: this.state.customerBAN,
        orderStatus: this.state.orderStatus,
        orderType: this.state.orderType,
        amount: this.state.amount,
        orderFromDate: this.state.orderFromDate,
        orderToDate: this.state.orderToDate,
        clientName: this.state.clientName,
        tenant: this.state.tenant,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Clear all search filters
  clearOrderTableSearch = () => {
    this.setState(
      {
        orderId: "",
        customerName: "",
        customerBAN: "",
        orderStatus: "",
        orderType: "",
        amount: "",
        clientName: "",
        orderFromDate: "",
        orderToDate: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Clear all search filters and refeesh data
  refreshOrderTableSearch = () => {
    this.setState(
      {
        orderId: "",
        customerName: "",
        customerBAN: "",
        orderStatus: "",
        orderType: "",
        amount: "",
        orderFromDate: "",
        orderToDate: "",
        clientName: "",
        page: 1,
        startRecord: 1,
        sortBy: "orderDate",
        sortOrder: "DESC",
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterOrderTable();
    }
  };

  classes = { ...orderClasses, ...reportClasses };

  // Render order view
  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          {/* <Paper className="tablePaper" elevation={0}> */}
          {/* Search filters start */}
          <Grid
            container
            spacing={1}
            style={{ marginBottom: "5px" }}
            justifyContent="flex-end"
          >
            {/* <div className={this.classes.searchOuterDiv} style={{ marginBottom: '5px' }}> */}

            {
              this.props.providerType === "SOLUTION_PROVIDER" && (
                // <div className={this.classes.searchInputDiv}>
                <Grid
                  item
                  size={{
                    xs: 6,
                    md: 2,
                  }}
                >
                  <Select
                    native
                    style={{ width: "100%" }}
                    size={"small"}
                    variant={"outlined"}
                    name={"tenant"}
                    inputProps={{
                      name: "tenant",
                      id: "outlined-native-tenant",
                    }}
                    //value={(a) => a.value}
                    value={this.state.tenant}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                    selectClass={
                      this.classes.inputClass +
                      " " +
                      this.classes.statusSelectBg +
                      " " +
                      this.classes.searchOrderSelect
                    }
                  >
                    {this.state.tenantList.map((a) => (
                      <option key={a.tenantId} value={a.tenantId}>
                        {a.tenantName}
                      </option>
                    ))}
                  </Select>
                </Grid>
              )
              // {/* </div> */}
            }
            <Grid
              item
              size={{
                xs: 6,
                md: 2,
              }}
            >
              {/* <div className={this.classes.searchInputDiv}> */}
              <Input
                size={"small"}
                variant={"outlined"}
                placeholder={t("ORDER_ID")}
                value={this.state.orderId}
                name={"orderId"}
                onChange={(e) => {
                  this.onChange(e);
                }}
                divClass={this.classes.inputClass}
                onKeyDown={(e) => {
                  this.onSearchKeyDown(e);
                }}
              />
              {/* </div> */}
            </Grid>
            {/* <div className={this.classes.searchInputDiv}> */}
            {/* <Input
                            size={'small'}
                            variant={'outlined'}
                            placeholder={t('Order Type')}
                            value={this.state.orderType}
                            name={"orderType"}
                            onChange={(e) => { this.onChange(e) }}
                            divClass={this.classes.inputClass}
                            onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                        /> */}

            {/* <Select
                            native
                            size={'small'}
                            variant={'outlined'}
                            name={'orderType'}
                            inputProps={{
                                name: 'orderType',
                                id: 'outlined-native-orderType',
                            }}
                            //value={(a) => a.value}
                            value={this.state.orderType}
                            onChange={(e) => { this.onChange(e) }}
                            onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                            selectClass={this.classes.inputClass, this.classes.statusSelectBg, this.classes.searchOrderSelect}
                        >
                            {this.state.orderTypeList
                                .map(a => (
                                    <option key={a.value} value={a.value}>{a.name}</option>
                                ))}
                        </Select> */}
            {/* </div> */}

            {(this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
              this.props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
              <>
                <Grid
                  item
                  size={{
                    xs: 6,
                    md: 2,
                  }}
                >
                  {/* <div className={this.classes.searchInputDiv}> */}
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("CUSTOMER_NAME")}
                    value={this.state.customerName}
                    name={"customerName"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={this.classes.inputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  />
                  {/* </div> */}
                </Grid>
                {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                  <Grid
                    item
                    size={{
                      xs: 6,
                      md: 2,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      placeholder={t("CUSTOMER_BAN")}
                      value={this.state.customerBAN}
                      name={"customerBAN"}
                      onChange={(e) => {
                        this.onChange(e);
                      }}
                      divClass={this.classes.inputClass}
                      onKeyDown={(e) => {
                        this.onSearchKeyDown(e);
                      }}
                    />
                  </Grid>
                )}
              </>
            )}
            <Grid
              item
              size={{
                xs: 6,
                md: 2,
              }}
            >
              {/* <div className={this.classes.searchInputDiv}> */}
              <Input
                size={"small"}
                variant={"outlined"}
                placeholder={t("Owner")}
                value={this.state.clientName}
                name={"clientName"}
                onChange={(e) => {
                  this.onChange(e);
                }}
                divClass={this.classes.inputClass}
                onKeyDown={(e) => {
                  this.onSearchKeyDown(e);
                }}
              />
            </Grid>
            {/* </div>
                            
                            <div className={this.classes.searchInputDiv}> */}
            {/* <Select
                            selectClass={this.classes.inputClass, classes.statusSelectBg, classes.selectHeight}
                            name={'orderStatus'}
                            selected={this.state.orderStatus}
                            options={this.state.statusList}
                            optionLabel={(a) => a.name}
                            value={(a) => a.value}
                            onChange={(e) => { this.onChange(e) }}
                            onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                        /> */}
            <Grid
              item
              size={{
                xs: 6,
                md: 2,
              }}
            >
              {/* <Select
                                native
                                style={{ width: '100%' }}
                                size={'small'}
                                variant={'outlined'}
                                name={'orderStatus'}
                                inputProps={{
                                    name: 'orderStatus',
                                    id: 'outlined-native-orderStatus',
                                }}
                                //value={(a) => a.value}
                                value={this.state.orderStatus}
                                onChange={(e) => { this.onChange(e) }}
                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                selectClass={this.classes.inputClass + ' ' + this.classes.statusSelectBg + ' ' + this.classes.searchOrderSelect}
                            >
                                {this.state.statusList
                                    .map(a => (
                                        <option key={a.value} value={a.value}>{a.value}</option>
                                    ))}
                            </Select> */}
              {this.state.displayOrderStatus && (
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                >
                  <InputLabel htmlFor="outlined-native-orderStatus">
                    {t("STATUS")}
                  </InputLabel>
                  <Select
                    native
                    label="STATUS "
                    value={this.state.orderStatus}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    inputProps={{
                      name: "orderStatus",
                      id: "outlined-native-orderStatus",
                    }}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  >
                    {this.state.statusList.map((a) => (
                      <option key={a.value} value={a.value}>
                        {a.value}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Grid>
            {/* </div> */}
            {/* <div className={this.classes.searchInputDiv}>
                            <Input
                                size={'small'}
                                variant={'outlined'}
                                placeholder={t('AMOUNT')}
                                // style={{ width: '100px' }}
                                value={this.state.amount}
                                name={"amount"}
                                onChange={(e) => { this.onChange(e) }}
                                divClass={this.classes.setInputClass}
                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                            />
                        </div> */}
            {/* <div className={`${this.classes.searchInputDiv} customDateReportFilterInput`}> */}
            <Grid
              item
              size={{
                xs: 6,
                md: 2,
              }}
            >
              <TextField
                name="orderFromDate"
                id="dateFrom"
                type="date"
                value={this.state.orderFromDate}
                label={t("Order From")}
                // style={{ width: '125px' }}
                InputLabelProps={{
                  shrink: true,
                }}
                variant={"outlined"}
                size={"small"}
                onChange={(e) => {
                  this.onChange(e);
                }}
                inputProps={{ max: this.state.today, format: "yyyy-MM-dd" }}
              />
            </Grid>
            {/* </div> */}
            <Grid
              item
              size={{
                xs: 6,
                md: 2,
              }}
            >
              {/* <div className={`${this.classes.searchInputDiv} customDateReportFilterInput`}> */}
              <TextField
                name="orderToDate"
                id="dateTo"
                type="date"
                value={this.state.orderToDate}
                label={t("Order To")}
                // style={{ width: '125px' }}
                InputLabelProps={{
                  shrink: true,
                }}
                variant={"outlined"}
                size={"small"}
                onChange={(e) => {
                  this.onChange(e);
                }}
                inputProps={{
                  min: this.state.orderFromDate,
                  max: this.state.today,
                  format: "yyyy-MM-dd",
                }}
              />
              {/* </div> */}
            </Grid>
            {/* <div className={this.classes.searchOrderLabelOuter} style={{ paddingRight: 0 }}>
                                <div className={this.classes.searchOrderLabelInner} style={{ paddingRight: 0 }}> */}
            <Grid
              item
              size={{
                xs: 6,
                md: 1,
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.filterOrderTable}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearOrderTableSearch}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
                {/* <Tooltip title="Refresh">
                                    <IconButton onClick={this.refreshOrderTableSearch}>
                                        <SyncIcon />
                                    </IconButton>
                                </Tooltip> */}
              </div>
            </Grid>
            {/* </div> */}
            {/* </div> */}
          </Grid>
          {/* Search filters end */}

          {/* Order table component */}
          <Card variant="outlined" style={{ borderRadius: "8px" }}>
            <OrderTable
              orderId={this.state.orderId}
              customerName={this.state.customerName}
              customerBAN={this.state.customerBAN}
              orders={this.state.orders}
              openResendDialog={this.openResendDialog}
              rowsPerPage={this.state.rowsPerPage}
              totalOrderCount={this.state.totalOrderCount}
              page={this.state.page}
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              updateSorting={this.updateSorting}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              controls={this.state.controls}
              loggedInUserType={this.props.loggedInUserType}
              providerType={this.props.providerType}
            />
          </Card>
          {/* </Paper> */}
          {/* Resend confirmation dialog component */}
          <ResendDialog
            isOpen={this.state.isMailDialog}
            close={this.closeMailDialog}
            orderId={this.state.actionOrderId}
          />
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(OrderReport));
